import { atom, useAtom } from 'jotai';

const turnaroundDestinationDeliveryId = atom<number | null>(null);

export const useTurnaroundDestinationDeliveryId = () => useAtom(turnaroundDestinationDeliveryId);
